import { colorPalette } from '../../colorPalette';
export const useStyles = (isPremium, logoBackgroundColor) => ({
    container: {
        position: 'relative',
        width: '227px',
        height: '167px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundColor: colorPalette.white,
    },
    altContainer: {
        position: 'relative',
        width: '167px',
        height: '167px',
        borderRadius: '15px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundColor: colorPalette.white,
    },
    containerMobile: {
        width: '95%',
        height: '120px',
        border: `${colorPalette.gray300} solid 1px`,
        borderRadius: '15px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundColor: colorPalette.white,
    },
    textContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'left',
        padding: '12px'
    },
    textContainerMobile: {
        width: '85%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'left',
        marginTop: '0px',
        marginLeft: '10px',
    },
    title: {
        fontWeight: 600,
        fontSize: '1.4rem',
    },
    text: {
        color: colorPalette.gray700,
        fontSize: '1.2rem',
    },
    backgroundImg: {
        backgroundColor: isPremium ? logoBackgroundColor : colorPalette.white,
        height: '40px',
        width: '120px',
        objectFit: 'scale-down',
        borderRadius: '8px'
    },
    backgroundImgMobile: {
        backgroundColor: isPremium ? logoBackgroundColor : colorPalette.white,
        height: '100%',
        width: '120px',
        borderRadius: '8px'
    },
    backgroundImgMobileContainer: {
        backgroundColor: isPremium ? logoBackgroundColor : colorPalette.white,
        height: '100%',
        width: '120px',
        borderRadius: '8px'
    },
    backgroundImgContainer: {
        backgroundColor: isPremium ? logoBackgroundColor : colorPalette.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50%',
        width: '100%',
        maxWidth: '100%',
        borderRadius: '8px'
    },
    iconContainer: {
        backgroundColor: colorPalette.white,
        borderRadius: '4px',
        position: 'absolute',
        top: '12px',
        left: '12px',
    }
});
